export const appConfig = {
  links: {
    helpPortal: "https://sportypost.featurebase.app/de/help",
    onboardingVideo: process.env.REACT_APP_ONBOARDING_VIDEO_URL || "/assets/onboarding/onboarding-video.mp4",
  },
};
